import { render, staticRenderFns } from "./ItemBadge.vue?vue&type=template&id=5441e34c&"
import script from "./ItemBadge.vue?vue&type=script&lang=js&"
export * from "./ItemBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports